export default {"src":"/_next/static/media/Widget2.dc11c3f8.svg","height":280,"width":341,"blurWidth":0,"blurHeight":0};